/**
 *  アクセスユーザのメンバーシップを表すクラス.
 */
export default class Membership {
    /**
     * @param {String} status
     */
    constructor(status) {
        this.status = status;
    }

    /**
     * membershipがゲストかどうか
     */
    get isGuest() {
        return this.status === 'GUEST';
    }

    /**
     * membershipがミニかどうか
     */
    get isMini() {
        return this.status === 'MINI';
    }

    /**
     * membershipがプレミアムかどうか
     */
    get isPremium() {
        return this.status === 'PREMIUM';
    }

    /**
     * 現在のmembershipから一段階課金した場合のmembership名を返す
     */
    get upgradeMembershipName() {
        return this.isPremium ? null : 'プレミアム会員'
    }

    /**
     * 現在のmembershipから一段階課金解除した場合のmembership名を返す
     */
    get downgradeMembershipName() {
        return this.isPremium ? '無料会員' : null
    }
}